<!--
 * @FileDescription: 标题骨架
 * @Author: 陈文景
 * @Date: 2023-03-09 16:49:23
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="skeleton">
    <div class="title">
      <strong>{{ title }}</strong>
    </div>

    <div class="content">
      <slot name="default" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.skeleton {
  color: #333;
  font-size: 14px;
  margin-bottom: 35px;
  &:nth-child(4) {
    margin-bottom: 0;
  }

  .title {
    position: relative;
    font-size: 16px;
    padding: 0 12px;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 2px;
      height: 100%;
      background-color: #99c41c;
    }
  }

  .content {
    padding-left: 12px;
    margin-top: 12px;
  }
}
</style>
